import { FxPageTable } from '@pc-fx-framework/components/page-table'
import { FxPageTableV2 } from '@pc-fx-framework/components/page-table-v2'
import { FxFileUpload } from '@pc-fx-framework/components/file-upload'
import { FxPageDetail } from '@pc-fx-framework/components/page-detail'
import { FxAnimPage } from '@pc-fx-framework/components/anim-page'
import { FxActionButton } from '@pc-fx-framework/components/action-button'

// 大屏组件
import { FxVPanel } from '@pc-fx-framework/components/visualized/panel'
import { FxVModal } from '@pc-fx-framework/components/visualized/modal'
import { FxVColumnChart } from '@pc-fx-framework/components/visualized/charts/column-chart'
import { FxVSpireColumnChart } from '@pc-fx-framework/components/visualized/charts/spire-column-chart'
import { FxVPieChart } from '@pc-fx-framework/components/visualized/charts/pie-chart'
import { FxVRosePieChart } from '@pc-fx-framework/components/visualized/charts/rose-pie-chart'
import { FxVScrollingBarChart } from '@pc-fx-framework/components/visualized/charts/scrolling-bar-chart'
import { FxVScrollingListChart } from '@pc-fx-framework/components/visualized/charts/scrolling-list-chart'
import { FxVPyramidChart } from '@pc-fx-framework/components/visualized/charts/pyramid-chart'
import { FxVLineChart } from '@pc-fx-framework/components/visualized/charts/line-chart'
import { FxVStackedBarChart } from '@pc-fx-framework/components/visualized/charts/stacked-bar-chart'
import { FxVProportionPieChart } from '@pc-fx-framework/components/visualized/charts/proportion-pie-chart'

import type { Plugin } from 'vue'

export default [
  FxPageTable,
  FxPageTableV2,
  FxFileUpload,
  FxPageDetail,
  FxAnimPage,
  FxActionButton,

  // 大屏组件
  FxVPanel,
  FxVModal,
  FxVColumnChart,
  FxVSpireColumnChart,
  FxVPieChart,
  FxVRosePieChart,
  FxVScrollingBarChart,
  FxVScrollingListChart,
  FxVPyramidChart,
  FxVLineChart,
  FxVStackedBarChart,
  FxVProportionPieChart,
] as Plugin[]

